export default __webpack_public_path__ + "static/media/slide_1.a6f27c63.jpg";